export default __webpack_public_path__ + "static/media/Royal Dragon Elite Helm.c74028c1.jpg";